import { render, staticRenderFns } from "./ManualStats.vue?vue&type=template&id=13b9e53a&"
import script from "./ManualStats.vue?vue&type=script&lang=js&"
export * from "./ManualStats.vue?vue&type=script&lang=js&"
import style0 from "./ManualStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports